import type { Node, Rect } from '../types';
import { boxToRect, getBoundsOfBoxes, getNodeRect, rectToBox } from './rect';

const EMPTY_RECT: Readonly<Rect> = Object.freeze({ x: 0, y: 0, width: 0, height: 0 });

/** Bounding rectangle of all nodes in flow space (v11 `getRectOfNodes`); empty input → zero rect. */
export const getRectOfNodes = (nodes: readonly Node[]): Rect => {
  if (nodes.length === 0) return { ...EMPTY_RECT };
  const boxes = nodes.map((node) => rectToBox(getNodeRect(node)));
  return boxToRect(boxes.reduce(getBoundsOfBoxes));
};
